module.exports = __webpack_public_path__ + "static/media/Expertise.e10a5a09.jpg";